export class ApproveDemandCompletionData {
    constructor(public readonly approved: boolean, public readonly explanation?: string) {}
}
